import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

function Contact() {
    const form = useRef();
    const [status, setStatus] = useState(''); // '', 'sending', 'success', 'error'

    const sendEmail = (e) => {
        e.preventDefault();
        setStatus('sending');

        emailjs
            .sendForm('service_t00r9m1', 'template_ih5grjv', form.current, 'SBtaAejsadStR-HHW')
            .then(
                () => {
                    setStatus('success');
                    form.current.reset();
                    setTimeout(() => setStatus(''), 5000);
                },
                (error) => {
                    console.log('FAILED...', error.text);
                    setStatus('error');
                    setTimeout(() => setStatus(''), 5000);
                },
            );
    };

    return (
        <section id="contact" className="py-32 bg-black relative">
            <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">

                <div className="flex flex-col items-center mb-24 animate-fade-in-up">
                    <h2 className="text-green-500 font-black tracking-widest text-sm uppercase mb-4">Engagement</h2>
                    <h3 className="text-6xl md:text-8xl font-black text-white text-center leading-none tracking-tighter uppercase mb-8">Let's <br /><span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-500 to-white text-glow">Connect.</span></h3>
                    <div className="w-20 h-1 bg-green-500 rounded-full"></div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">

                    {/* Contact Info Sidebar */}
                    <div className="lg:col-span-5 space-y-8 h-full">
                        <div className="glass-card p-12 rounded-[3.5rem] h-full flex flex-col justify-between">
                            <div className="space-y-12">
                                <h4 className="text-3xl font-black text-white uppercase tracking-tighter mb-4">Direct Lines</h4>

                                <div className="space-y-10">
                                    <a href="mailto:kwagalamoris@gmail.com" className="flex items-center gap-6 group">
                                        <div className="w-14 h-14 bg-green-500 rounded-2xl flex items-center justify-center text-black text-2xl group-hover:rotate-12 transition-all duration-500">
                                            <i className="bi bi-envelope-at-fill"></i>
                                        </div>
                                        <div>
                                            <p className="text-[10px] font-black text-gray-500 uppercase tracking-widest">Email</p>
                                            <p className="text-xl font-bold text-white group-hover:text-green-500 transition-colors">kwagalamoris@gmail.com</p>
                                        </div>
                                    </a>

                                    <a href="tel:+256787061827" className="flex items-center gap-6 group">
                                        <div className="w-14 h-14 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center text-green-500 text-2xl group-hover:-rotate-12 transition-all duration-500">
                                            <i className="bi bi-telephone-fill animate-bounce"></i>
                                        </div>
                                        <div>
                                            <p className="text-[10px] font-black text-gray-500 uppercase tracking-widest">Phone</p>
                                            <p className="text-xl font-bold text-white group-hover:text-green-500 transition-colors">+256 787 061827</p>
                                        </div>
                                    </a>

                                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-6 group">
                                        <div className="w-14 h-14 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center text-green-500 text-2xl group-hover:scale-110 transition-all duration-500">
                                            <i className="bi bi-linkedin"></i>
                                        </div>
                                        <div>
                                            <p className="text-[10px] font-black text-gray-500 uppercase tracking-widest">LinkedIn</p>
                                            <p className="text-xl font-bold text-white group-hover:text-green-500 transition-colors">Kwagala Moris Owen</p>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            <div className="pt-12 border-t border-white/5 mt-12">
                                <p className="text-gray-500 font-bold leading-relaxed">
                                    I am currently available for freelance projects and full-time inquiries in the East African region and beyond.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="lg:col-span-7">
                        <div className="glass-card p-12 md:p-16 rounded-[3.5rem]">
                            <form ref={form} onSubmit={sendEmail} className="space-y-8">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                    <div className="space-y-4">
                                        <label className="text-xs font-black text-gray-500 uppercase tracking-[0.2em] ml-2">Your Name</label>
                                        <input
                                            name="user_name"
                                            className="w-full bg-white/5 border border-white/10 rounded-2xl px-8 py-5 text-white outline-none focus:border-green-500/50 transition-all font-bold"
                                            placeholder="John Doe"
                                            required
                                        />
                                    </div>
                                    <div className="space-y-4">
                                        <label className="text-xs font-black text-gray-500 uppercase tracking-[0.2em] ml-2">Email Address</label>
                                        <input
                                            name="user_email"
                                            className="w-full bg-white/5 border border-white/10 rounded-2xl px-8 py-5 text-white outline-none focus:border-green-500/50 transition-all font-bold"
                                            placeholder="john@example.com"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="space-y-4">
                                    <label className="text-xs font-black text-gray-500 uppercase tracking-[0.2em] ml-2">Project Brief</label>
                                    <textarea
                                        name="message"
                                        className="w-full bg-white/5 border border-white/10 rounded-2xl px-8 py-5 text-white outline-none focus:border-green-500/50 transition-all font-bold resize-none"
                                        placeholder="How can I help you build the future?"
                                        required
                                    ></textarea>
                                </div>
                                <button
                                    type="submit"
                                    disabled={status === 'sending'}
                                    className={`btn-primary w-full md:w-auto mt-4 px-12 uppercase tracking-widest relative overflow-hidden group ${status === 'sending' ? 'opacity-70 cursor-not-allowed' : ''}`}
                                >
                                    <span className={status === 'sending' ? 'opacity-0' : 'opacity-100'}>
                                        {status === 'success' ? 'Message Sent!' : 'Shoot Message'}
                                    </span>
                                    {status === 'sending' && (
                                        <div className="absolute inset-0 flex items-center justify-center">
                                            <div className="w-5 h-5 border-2 border-black border-t-transparent rounded-full animate-spin"></div>
                                        </div>
                                    )}
                                </button>

                                {status === 'success' && (
                                    <p className="text-green-500 font-bold text-sm animate-bounce">
                                        ✨ High-five! Your message is on its way.
                                    </p>
                                )}
                                {status === 'error' && (
                                    <p className="text-red-500 font-bold text-sm">
                                        Oops! Something went wrong. Please try again.
                                    </p>
                                )}
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default Contact;
